import { TabPane } from 'element-ui'

const YTabPane = TabPane
YTabPane.$depends = [TabPane]
YTabPane.$name = 'y-tab-pane'
YTabPane._name = 'TabPane 标签页内容'

export default YTabPane
